export default __webpack_public_path__ + "static/media/volume.58584b38.svg";